/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  MixedWidget2,
  MixedWidget10,
  MixedWidget11,
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget5,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
} from '../../../_metronic/partials/widgets'
import { Button, Col, Row } from 'react-bootstrap-v5'
import { getPermissao, permissaoPorListaUsuario } from '../../../util'
import { tipoPerfil, tipoPermissao } from '../../modules/portal/tipos/tipos'

const VerificarPermissao = () => permissaoPorListaUsuario([831, 809, 830, 815, 806, 393, 885, 886, 20, 43, 1037, 42, 617, 990]); 

const DashboardPage: FC = () => (
  <>
    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
      <div className='col-xxl-4'>
        <MixedWidget2
          className='card-xl-stretch mb-xl-8'
          chartColor='danger'
          chartHeight='200px'
          strokeColor='#cb1e46'
        />
      </div>
      <div className='col-xxl-4'>
        <ListsWidget5 className='card-xxl-stretch' />
      </div>
      <div className='col-xxl-4'>
        <MixedWidget10
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='150px'
        />
        <MixedWidget11
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='175px'
        />
      </div>
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gy-5 gx-xl-8'>
      <div className='col-xxl-4'>
        <ListsWidget3 className='card-xxl-stretch mb-xl-3' />
      </div>
      <div className='col-xl-8'>
        <TablesWidget10 className='card-xxl-stretch mb-5 mb-xl-8' />
      </div>
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-4'>
        <ListsWidget2 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget6 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' items={5} />
        {/* partials/widgets/lists/_widget-4', 'class' => 'card-xl-stretch mb-5 mb-xl-8', 'items' => '5' */}
      </div>
    </div>
    {/* end::Row */}

    <div className='row g-5 gx-xxl-8'>
      <div className='col-xxl-4'>
        <MixedWidget8
          className='card-xxl-stretch mb-xl-3'
          chartColor='success'
          chartHeight='150px'
        />
      </div>
      <div className='col-xxl-8'>
        <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' />
      </div>
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
          <Row className="g-8"> {/* Adiciona espa�amento entre os itens */}
              {getPermissao(tipoPermissao.criar_proposta) && (
                  <Col className="col-6 col-md-2 mb-2">
                      <a href="/propostas">
                          <Button className="w-100">
                              <i className="fa fa-cubes"></i>
                              <p>Propostas</p>
                          </Button>
                      </a>
                  </Col>
              )}

              {getPermissao(tipoPermissao.criar_revendedor, tipoPerfil.Backoffice) && (
                  <Col className="col-6 col-md-2 mb-2">
                      <a href="/empresa">
                          <Button className="w-100">
                              <i className="fa fa-home"></i>
                              <p>Empresas</p>
                          </Button>
                      </a>
                  </Col>
              )}

              {getPermissao(tipoPermissao.listar_usuario, tipoPerfil.Backoffice) && (
                  <Col className="col-6 col-md-2 mb-2">
                      <a href="/usuarios">
                          <Button className="w-100">
                              <i className="fa fa-user"></i>
                              <p>Usuarios</p>
                          </Button>
                      </a>
                  </Col>
              )}

              {VerificarPermissao() && (
                  <Col className="col-6 col-md-2 mb-2">
                      <a href="/dashboard/graficos">
                          <Button className="w-100">
                              <i className="fa fa-chart-line"></i>
                              <p>Dashboard</p>
                          </Button>
                      </a>
                  </Col>
              )}
          </Row>

    </>
  )
}

export { DashboardWrapper }
